import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { StartupConfiguration } from '../model/startup-configuration';
import { HelperService } from '../services/helper.service';

// tslint:disable-next-line:ban-types
export function bootstrap(injector: Injector): Function {
  return () => {
    return new Promise<void>(resolve => {
      const http: HttpClient = injector.get(HttpClient);
      const helperService: HelperService = injector.get(HelperService);
      http.get<StartupConfiguration>(environment.configFilePath).subscribe(configuration => {
        helperService.setStartupConfiguration(configuration);
        const translateService: TranslateService = injector.get(TranslateService);
        translateService.addLangs(configuration.availableLanguages);
        translateService.use(configuration.defaultLanguage).subscribe(() => {
          resolve();
        });
      });
    });
  };
}
